// Custom app scripts


// Init input file component

import bsCustomFileInput from 'bs-custom-file-input';

$(function () {
    window.onpageshow = function (e) {
        // fix for safari persisted back/forward buttons
        // by default safari loads from cache when using nav buttons
        // which can lead to unexpected script issues as all events are not fired as expected
        if (e.persisted) {
            window.location.reload()
        }
    };

    bsCustomFileInput.init();
});

global.Utils = (function () {
    function getRecaptchaSiteKey() {
        const siteKey = $('body').data('recaptcha-site-key') || '';
        return siteKey;
    }

    function checkLogin(checkApi, loginUrl) {
        $.ajax({
            url: checkApi + "api/logincheck",
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                if (data == true) {
                    window.location.replace(loginUrl);
                }
            }
        });
    }

    return {
        getRecaptchaSiteKey: getRecaptchaSiteKey,
        checkLogin: checkLogin
    }
})();
